import React, { useEffect, useState} from 'react';
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from "react-redux";
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector(state => state.auth)
  const [isAuthenticated, setIsAuthenticated] = useState(null) 
   
  useEffect(() => {
    let token = localStorage.getItem('jwToken')
        if(token){
            let tokenExpiration = jwtDecode(token).exp;
            // console.log(tokenExpiration)
            let dateNow = new Date();

            if(tokenExpiration < dateNow.getTime()/1000){
                console.log('Token abgelaufen')
                setIsAuthenticated(false)
            }else{
            //  setIsAuthenticated('nicht angelaufen')
            setIsAuthenticated(true)
            }
        } else {
           setIsAuthenticated(false)
        }
    // eslint-disable-next-line
  }, [auth])

  if(isAuthenticated === null){
    return <></>
  }

  return (
      !isAuthenticated ? (
        <Navigate to='/'/>
      ) : (
        <Outlet/>
      )
  );
};


export default PrivateRoute;
